import { FC, RefObject, useRef } from 'react';

import { TextFieldRef } from 'components/inputs/text-field';

import { ChassisColumn, ContainerColumn, GensetColumn } from '.';
import { useNewTransaction } from '../new-transaction.context';

import './equipment.scss';
import TrailerColumn from './trailer';

export type EquipmentProps = {
  chassisRef: RefObject<TextFieldRef>;
  containerRef: RefObject<TextFieldRef>;
  gensetRef: RefObject<TextFieldRef>;
  required?: boolean;
};

const EquipmentInformation: FC = () => {
  const { isTrailer, unstack, setUnstack, transaction } = useNewTransaction();

  const containerRef = useRef<TextFieldRef>(null);
  const chassisRef = useRef<TextFieldRef>(null);
  const gensetRef = useRef<TextFieldRef>(null);

  return (
    <div id="equipment-grid" className="grid-3">
      <div className="col-start-1 g-inherit h-100">
        <ContainerColumn
          chassisRef={chassisRef}
          containerRef={containerRef}
          gensetRef={gensetRef}
          required={chassisRef.current?.isBlank() && gensetRef.current?.isBlank()}
        />
      </div>
      <div className="col-start-2 g-inherit h-100">
        {isTrailer ? (
          <TrailerColumn />
        ) : (
          <ChassisColumn
            chassisRef={chassisRef}
            containerRef={containerRef}
            gensetRef={gensetRef}
            required={!containerRef.current?.isBlank() || gensetRef.current?.isBlank()}
          />
        )}
      </div>
      <div className="col-start-3 g-inherit h-100">
        <GensetColumn
          chassisRef={chassisRef}
          containerRef={containerRef}
          gensetRef={gensetRef}
          required={containerRef.current?.isBlank() && chassisRef.current?.isBlank()}
        />
      </div>
      <div/>
      {transaction.inbound && (
          <div className="checkboxes d-flex g-2 h-100 align-items-center justify-content-center margin-top-negative-22px">
            <label className="font-weight-bold margin-right-8px">UNSTACK</label>
            <input
              type="checkbox"
              checked={unstack}
              onChange={e => setUnstack(e.target.checked)}
            />
          </div>
        )}
    </div>
  );
};

export default EquipmentInformation;
